import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { submit, isSubmitting } from 'redux-form';

import Button from 'components/common/Button';

import SalesRepresentativesAddForm from './SalesRepresentativesAddForm';

const styles = theme => ({
  form: {
    padding: '35px 40px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px 8px 16px',
    },
  },
});

const SalesRepresentativesAddDialog = ({
  open,
  onClose,
  onCreateButtonClick,
  onSubmitSuccess,
  submitting,
  actions,
  formValues,
  classes,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
  >
    <DialogTitle>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        Sales Representative
      </Typography>
    </DialogTitle>
    <DialogContent>
      <SalesRepresentativesAddForm
        className={classes.form}
        onCreateButtonClick={onCreateButtonClick}
        onSubmitSuccess={(values) => {
          onSubmitSuccess(values);
        }}
        variant="dialog"
        formValues={formValues}
      />
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        variant="raised"
      >
        Cancel
      </Button>
      <Button
        onClick={() => actions.submit('salesRepresentativesAdd')}
        variant="raised"
        color="primary"
        disabled={submitting}
      >
        Done
      </Button>
    </DialogActions>
  </Dialog>
);

SalesRepresentativesAddDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  onCreateButtonClick: PropTypes.func,
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

SalesRepresentativesAddDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onSubmitSuccess: () => {},
  onCreateButtonClick: () => {},
  formValues: {},
};

const mapStateToProps = store => ({
  submitting: isSubmitting('salesRepresentativesAdd')(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(SalesRepresentativesAddDialog),
);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/SalesRepresentatives/SalesRepresentativesAddDialog.js